import { jsx as _jsx } from "react/jsx-runtime";
import { createOverlayCoordinator, OverlayCoordinatorContext, } from '#pplx/frontend/aether/internal/overlay/useOverlay.js';
import { useState } from 'react';
export function OverlayCoordinatorProvider({ children }) {
    const [overlayCoordinator] = useState(createOverlayCoordinator);
    return (_jsx(OverlayCoordinatorContext.Provider, { value: overlayCoordinator, children: children }));
}
//# sourceMappingURL=OverlayCoordinatorProvider.js.map